/* import __COLOCATED_TEMPLATE__ from './cta-form.hbs'; */
/* RESPONSIBLE TEAM: team-web */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { equal } from '@ember/object/computed';

export default Component.extend({
  classNames: ['u__display-inline-block'],
  isSmall: equal('size', 'small'),

  navigateToSignUp() {
    window.location.href = 'https://app.intercom.com/admins/sign_up';
  },
});
